import BaseUIStoreSettingPaperangView from 'xui/modules/print/BaseUIStoreSettingPaperangView'

export default class StoreSettingPaperang extends BaseUIStoreSettingPaperangView {
  static displayName = 'StoreSettingPaperang'

  static navigationOptions = {
    header: null,
  }
}
